export const PROJECT_MODAL_TITLE = 'project-modal-title'
export const PROJECT_MODAL_PROJECT_NAME = 'project-modal-project-name'
export const PROJECT_MODAL_STYLE_SELECT = 'project-modal-style-select'
export const PROJECT_MODAL_CREATE_EDIT_BUTTON = 'project-modal-create-edit-button'
